import { createReducer, on } from '@ngrx/store';
import { SelectedDocTypeActions } from '../actions/selected-doc-type.actions';
import { SelectedDocTypeState } from '../states/app.state';

export const initialState: SelectedDocTypeState = {
  selectedDocType: '',
};

export const selectedDocTypeReducer = createReducer(
  initialState,
  on(SelectedDocTypeActions.setSelectedDocType, (state, { selectedDocType }) => ({
    ...state,
    selectedDocType,
  })),
  on(SelectedDocTypeActions.clearSelectedDocType, state => ({
    ...state,
    selectedDocType: '',
  }))
);